import React from 'react'
import Tabs from "@mui/material/Tabs"
import Tab from "@mui/material/Tab"
import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
//import "./ViewAllCommon.scss"
import { useHistory } from "react-router"
import AddSubCategory from './AddSubCategory'
import ViewSubCategoryInfo from './ViewSubCategoryInfo'



function SubCategoryMain() {
  interface TabPanelProps {
    children?: React.ReactNode
    index: number
    value: number
  }
  function TabPanel(props: TabPanelProps) {
    const { children, value, index, ...other } = props

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    )
  }

  function a11yProps(index: number) {
    return {
      id: `simple-tab-${index}`,
      "aria-controls": `simple-tabpanel-${index}`,
    }
  }

  const [value, setValue] = React.useState(0)

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue)
  }
  const history = useHistory()

  return (
    <>
      <div style={{ display: 'flex', marginTop: '20px' }}>
        <div
          className="approval-back-image"
          onClick={() => {
            history.goBack()
          }}
        >
          <img
            src="../../assets/images/back-icon.svg"
            height={"60px"}
            width={"60px"}
            alt="back button"
            className="back_button"

          />
        </div>
        <div className='pending-request-heading'>SubCategories</div>
      </div>





      <Box sx={{ width: "100%", marginTop: "20px" }}>
        <Box sx={{}}>
          <Tabs
            TabIndicatorProps={{
              sx: {
                bgcolor: "blue",
                height: "2px",
                color: "blue",
              },
            }}
            value={value}
            onChange={handleChange}
            aria-label="basic tabs example"
          >

            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="Add New SubCategory"
              {...a11yProps(0)}
            />


            <Tab
              sx={{
                textTransform: "none",
                fontSize: "20px",
                fontWeight: "700",
              }}
              label="View All Category Details"
              {...a11yProps(1)}
            />


          </Tabs>
        </Box>
        <TabPanel value={value} index={0}>
          <AddSubCategory />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <ViewSubCategoryInfo />
        </TabPanel>


      </Box>

    </>

  )
}

export default SubCategoryMain